import type { DefaultPassThrough } from '@primevue/core'
import type { TabPassThroughMethodOptions, TabPassThroughOptions } from 'primevue/tab'
import type { TabPanelsPassThroughOptions } from 'primevue/tabpanels'
import type { TabListPassThroughOptions } from 'primevue/tablist'
import type { TabsDesignTokens } from '@primeuix/themes/types/tabs'

export const TabPanelsPassThroughConfig: DefaultPassThrough<TabPanelsPassThroughOptions> = {
  root: { class: 'tw-w-full' }
}

export const TabListPassThroughConfig: DefaultPassThrough<TabListPassThroughOptions> = {
  tabList: { class: 'tw-flex tw-gap-8 tw-w-full' }
}

export const TabPassThroughConfig: DefaultPassThrough<TabPassThroughOptions> = {
  root: ({ context }: TabPassThroughMethodOptions) => ({
    class: [context?.active && '!tw-font-semibold']
  })
}

export const TabStyleConfig: TabsDesignTokens = {
  root: {
    transitionDuration: '{transition.duration}'
  },
  tablist: {
    borderWidth: '0 0 1px 0',
    background: '{content.background}',
    borderColor: '{content.border.color}'
  },
  tab: {
    background: 'transparent',
    hoverBackground: 'transparent',
    activeBackground: 'transparent',
    borderWidth: '0 0 1px 0',
    borderColor: '{content.border.color}',
    hoverBorderColor: '{content.border.color}',
    activeBorderColor: '{primary.color}',
    color: 'var(--color-text-subdued)',
    hoverColor: 'var(--color-text)',
    activeColor: 'var(--color-text)',
    fontWeight: '400',
    padding: '0.75rem 0rem',
    margin: '0 0 -1px 0',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '-1px',
      shadow: '{focus.ring.shadow}'
    }
  },
  tabpanel: {
    background: 'var(--color-transparent)',
    color: '{content.color}',
    padding: undefined,
    focusRing: {
      width: '0px',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: 'inset {focus.ring.shadow}'
    }
  },
  navButton: {
    background: '{content.background}',
    color: '{text.muted.color}',
    hoverColor: '{text.color}',
    width: '2.5rem',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '-1px',
      shadow: '{focus.ring.shadow}'
    }
  },
  activeBar: {
    height: '3px',
    background: '{primary.color}'
  },
  colorScheme: {
    light: {
      navButton: {
        shadow: '0px 0px 10px 50px rgba(255, 255, 255, 0.6)'
      }
    },
    dark: {
      navButton: {
        shadow: '0px 0px 10px 50px color-mix(in srgb, {content.background}, transparent 50%)'
      }
    }
  }
}
